<template>
	<div class="t-page_home">
		<section class="t-promo">
			<h1><span v-if="mobileState">{{ header.logo }}</span>{{ pageText.title }}</h1>
      <p class="t-promo__subtitle">{{pageText.subtitle}}</p>
			<div class="t-promo-slider" v-if="mobileState">
				<swiper :options="swiperOption" ref="description" v-if="mobileState">
					<swiper-slide>
						<div class="t-promo__img t-promo__img_step1">
							<img src="/img/promo/step_1/1.png">
							<img src="/img/promo/step_1/2.png">
							<img src="/img/promo/step_1/3.png">
							<img src="/img/promo/step_1/4.png">
						</div>
						<p>{{ pageText.promo_1 }}</p>
					</swiper-slide>
					<swiper-slide>
						<div class="t-promo__img t-promo__img_step2">
							<img src="/img/promo/step_2/1.png">
							<img src="/img/promo/step_2/2.png">
							<img src="/img/promo/step_2/3.png">
							<img src="/img/promo/step_2/4.png">
							<img src="/img/promo/step_2/5.png">
						</div>
						<p>{{ pageText.promo_2 }}</p>
					</swiper-slide>
					<swiper-slide>
						<div class="t-promo__img t-promo__img_step3">
							<img src="/img/promo/step_3/1.png">
							<img src="/img/promo/step_3/2.png">
							<img src="/img/promo/step_3/3.png">
							<img src="/img/promo/step_3/4.png">
						</div>
						<p>{{ pageText.promo_3 }}</p>
					</swiper-slide>
				</swiper>
				<div class="t-promo-slider__pagination"></div>
			</div>
			<ul class="t-promo__descriptionList" v-else>
				<li>
					<div class="t-promo__img t-promo__img_step1" @mousemove="Move($event)" @mouseout="Out($event)">
						<img src="/img/promo/step_1/1.png">
						<img src="/img/promo/step_1/2.png">
						<img src="/img/promo/step_1/3.png">
						<img src="/img/promo/step_1/4.png">
					</div>
					<p>{{ pageText.promo_1 }}</p>
				</li>
				<li>
					<div class="t-promo__img t-promo__img_step2" @mousemove="Move($event)" @mouseout="Out($event)">
						<img src="/img/promo/step_2/1.png">
						<img src="/img/promo/step_2/2.png">
						<img src="/img/promo/step_2/3.png">
						<img src="/img/promo/step_2/4.png">
						<img src="/img/promo/step_2/5.png">
					</div>
					<p>{{ pageText.promo_2 }}</p>
				</li>
				<li>
					<div class="t-promo__img t-promo__img_step3" @mousemove="Move($event)" @mouseout="Out($event)">
						<img src="/img/promo/step_3/1.png">
						<img src="/img/promo/step_3/2.png">
						<img src="/img/promo/step_3/3.png">
						<img src="/img/promo/step_3/4.png">
					</div>
					<p>{{ pageText.promo_3 }}</p>
				</li>
			</ul>
      <div class="t-promo__buttons_new">
        <div class="t-promo__buttons_new__section">
			<div class="t-promo__buttons_new__section__description">
				<h3>{{pageText.study_title}}</h3>
				<p>{{pageText.study_desc}}</p>
			</div>
			<router-link :to="{name: 'courses'}" class="t-btn t-btn_120"><span>{{ pageText.study }}</span></router-link>
        </div>
        <div class="t-promo__buttons_new__section t-promo__buttons_new__section__second">
			<div class="t-promo__buttons_new__section__description">
				<h3>{{pageText.teach_title}}</h3>
				<p>{{pageText.teach_desc}}</p>
			</div>
			<router-link :to="{name: 'courses_create'}" class="t-btn t-btn_120" v-if="hasAuth"><span>{{ pageText.teach }}</span>
			</router-link>
			<button class="t-btn t-btn_120" @click.stop.prevent="modalDialogType_registrationOpen()" v-else><span>{{ pageText.teach }}</span>
			</button>
        </div>
      </div>
			<div class="t-promo__search">
				<h2>{{ pageText.coursesTitle }}</h2>
				<cmp-search :type="'search'"></cmp-search>
			</div>
		</section>

		<cmp-courses-list :type="'popular'"></cmp-courses-list>

		<cmp-popular-teachers class="t-teachers_home"></cmp-popular-teachers>
	</div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/main.json' : 'staticText',
        main: {
            title: "Выбирайте тему, бронируйте урок, курс или консультацию",
            subtitle: "Индивидуальное обучение через Skype или другую программу для чатов. Учитесь новому, преподавайте то, что знаете.",
            promo_1: 'Выбирайте интересный урок',
            promo_2: 'Удобное время',
            promo_3: 'Начинайте учиться',
            teach: 'Учить',
            or: 'или',
            study: 'Учиться',
            coursesTitle: 'Найдите интересные уроки и курсы',
            teach_title: "Учить просто",
            teach_desc: "У вас знания, опыт, экспертиза? Регистрируйте свои уроки, курсы, консультации. Работайте не выходя из дома.",
            study_title: "Учиться легко",
            study_desc: "Живые уроки один на один с преподавателем или в группе. Учитесь онлайн."
        }
    };

    import {store} from '../store'

    import {mapActions, mapGetters} from 'vuex';

    import CoursesList from '../vue_components/CoursesList.vue'
    import PopularTeachers from '../vue_components/PopularTeachers.vue'

    export default {
		data(){
			return{
				pageText: {},
				swiperOption: {
					autoHeight: true,
					slidesPerView: 1,
					spaceBetween: 24,
					pagination: {
						el: '.t-promo-slider__pagination'
					}
				}
			}
		},
      	components: {
			'cmp-courses-list': CoursesList,
			'cmp-popular-teachers': PopularTeachers
		},
		computed: {
			...mapGetters(['mobileState']),
			...mapGetters('profile', {
				hasAuth: 'hasAuth'
						}),
			...mapGetters('staticText', ['header'])
		},
		methods: {
			...mapActions(['UpdatePreloadState']),
			...mapActions('modal', ['modalDialogType_registrationOpen']),
			...mapActions('coursesList', {
				setCourses: 'setItems'
						}),
			...mapActions('teachers', {
				setTeachers: 'setItems'
			}),
			Move(e){
				let mouse_pos = e.layerX;
				let center = e.target.clientWidth / 2;
				let img_arr = e.target.children;
				if(img_arr.length > 0){
										let pos = (center - mouse_pos) / 10;
					img_arr[0].style.transform = 'translateX(' + pos + 'px)';
								}
				if(img_arr.length > 1){
					let pos = (center - mouse_pos) / 12;
					img_arr[1].style.transform = 'translateX(' + pos + 'px)';
				}
				if(img_arr.length > 2){
					let pos = (mouse_pos - center) / 10;
					img_arr[2].style.transform = 'translateX(' + pos + 'px)';
				}
				if(img_arr.length > 3){
					let pos = (mouse_pos - center) / 11;
					img_arr[3].style.transform = 'translateX(' + pos + 'px)';
				}
				if(img_arr.length > 4){
					let pos = (center - mouse_pos) / 10;
					img_arr[4].style.transform = 'translateX(' + pos + 'px)';
				}
			},
			Out(e){
				let img_arr = e.target.children;

				for(let i = 0; i < img_arr.length; i++){
					img_arr[i].style.transform = 'translateX(0)';
				}
			},
			Load(pageText){
				this.pageText = pageText;
				setTimeout(() => {
					this.UpdatePreloadState(false);
				}, 500)
			}
		},
		beforeRouteLeave (to, from, next) {
				this.UpdatePreloadState(true);
				next();
		},
		beforeRouteEnter (to, from, next) {
			let count = 0;

			let pageText = {};

			store.dispatch('staticText/LoadPageText', localeText).then((data) => {
				pageText = data;

				count++;
				RunNext();
			});

			store.dispatch('staticText/LoadCoursesListText').then(() => {count++;RunNext();});
			store.dispatch('staticText/LoadPopularTeachersText').then(() => {count++;RunNext();});

			store.dispatch('coursesList/LoadCoursesPopular').then(() => {
				count++;
				RunNext();
			});

			store.dispatch('profile/LoadUserInfo').then(() => {
				count++;
				RunNext();
			});

			store.dispatch('teachers/LoadTeachers').then(() => {
				count++;
				RunNext();
			});

			let RunNext = () => {
				if(count > 5)
					next(vm => vm.Load(pageText))
			}
		}
	}
</script>

<style lang="sass">
.t-page_home
	h1
		line-height: 1.2
		font-size: 44px
		margin: 0 auto 13px
		max-width: 770px
		text-align: center
	.t-coursesList
		width: 984px
		max-width: 100%
		margin: 0 auto 64px
.t-promo__buttons .t-btn
  min-width: 120px
.t-promo__buttons_new
  display: flex
  flex-direction: row
  width: 950px
  justify-content: space-between
  margin-bottom: 66px
  h3
    font-size: 28px
    line-height: 1.2
    color: #52A8F2
    text-align: center
    margin-bottom: 10px
.t-promo__buttons_new__section
  max-width: 370px
  text-align: center
  &__second
    max-width: 470px
.t-promo__buttons_new__section__description
  border-bottom: 1px solid #DEF1FA
  margin-bottom: 10px
  padding-bottom: 10px
.t-promo__subtitle
  max-width: 600px
  text-align: center
.t-promo
	overflow: hidden
	padding: 17px 24px 37px
	display: flex
	flex-direction: column
	align-items: center
	background: #ffffff
	margin: 0 auto 45px
	&__descriptionList
		margin: 0 auto 59px
		width: 100%
		display: flex
		align-items: flex-start
		justify-content: center
		list-style-type: none
		li
			width: 320px
			max-width: calc(100% / 3)
		p
			color: $blue
			text-align: center
	&__buttons
		display: flex
		align-items: center
		justify-content: center
		margin-bottom: 66px
		position: relative
		p
			color: $blue
			margin: 0 16px
		&:before, &:after
			content: ''
			position: absolute
			top: 50%
			width: 313px
			height: 1px
			background: $input
		&:before
			right: 100%
			margin-right: 16px
		&:after
			left: 100%
			margin-left: 16px
	&__search
		max-width: 720px
		width: 100%
		margin: 0 auto
		.t-search
			max-width: 100%
		h2
			margin-bottom: 24px
			font-size: 36px
			line-height: 1.2
			color: $blue
			text-align: center

.t-promo__img
	position: relative
	width: 100%
	padding-bottom: 100%
	img
		position: absolute
		pointer-events: none
		transition: transform .2s linear
	&_step1
		img
			&:nth-child(4)
				top: 13.5%
				left: 19.8%
				z-index: 3
				width: 21.25%
			&:nth-child(2)
				top: 21%
				left: 29%
				z-index: 2
				width: 36.563%
			&:nth-child(3)
				top: 27%
				left: 10%
				z-index: 4
				width: 80%
			&:nth-child(1)
				top: 19%
				left: 18%
				width: 63.75%
				z-index: 1
	&_step2
		img
			&:nth-child(1)
				top: 17%
				left: 13%
				width: 75%
				z-index: 1
			&:nth-child(2)
				z-index: 3
				top: 16%
				left: 45%
				width: 40.625%
			&:nth-child(3)
				z-index: 4
				top: 34%
				left: 26%
				width: 14.375%
			&:nth-child(4)
				z-index: 4
				top: 14%
				left: 46.5%
				width: 6.875%
			&:nth-child(5)
				z-index: 2
				top: 19%
				left: 22%
				width: 53.125%
	&_step3
		img
			&:nth-child(1)
				z-index: 1
				left: 8%
				top: 20%
				width: 78.75%
			&:nth-child(2)
				z-index: 2
				top: 17%
				left: 31%
				width: 46.875%
			&:nth-child(3)
				z-index: 3
				top: 25%
				left: 29%
				width: 62.813%
			&:nth-child(4)
				z-index: 4
				top: 57%
				left: 11%
				width: 27.19%

@media (max-width: 1000px)
	.t-teachers_home
		padding: 0 12px
	.t-promo__buttons_new
		max-width: 100%
@media (max-width: 769px)
	.t-page_home
		h1
			font-size: 14px
			margin: 0
			padding: 0
			span
				display: block
				font-size: 36px
				margin-bottom: 8px
		.t-coursesList
			margin-bottom: 48px
	.t-promo__buttons_new
		flex-direction: column
		width: auto
	.t-promo__buttons_new__section
		max-width: 300px
		margin: 0 auto 66px auto
	.t-promo
		padding: 16px
		margin-top: -16px
		margin-bottom: 32px
		&__buttons
			margin-bottom: 32px
			flex-direction: column
			width: 100%
			&:before, &:after
				content: none
			.t-btn
				width: 100%
				&:first-child
					margin-bottom: 16px
		&__search
			h2
				margin-bottom: 16px
				font-size: 24px

	.t-promo-slider
		display: flex
		flex-direction: column
		margin: 0 -16px 24px
		width: calc(100% + 32px)
		.swiper-container
			width: 100%
			margin-bottom: 16px
		.swiper-slide
			padding: 0 16px
			display: flex
			flex-direction: column
			align-items: center
			p
				color: $blue
		&__pagination
			display: flex
			align-items: center
			justify-content: center
			.swiper-pagination-bullet
				margin: 0 2px
				background: $disabled
				opacity: 1
			.swiper-pagination-bullet-active
				background: $turquoise
</style>



// WEBPACK FOOTER //
// src/vue_pages/Index.vue